module.exports = __webpack_public_path__ + "img/brand-10.6656fb78.png";